import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <main>
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-half">
            <img src="/generated/editorial/scene-01.webp" alt="Summer clothing rack" />
          </div>

          <div className="hero-text">
            <h2>isanroute Summer Sale</h2>
          </div>
        </section>

        {/* Sale Section */}
        <section className="sale-section">
          <h2>Sale</h2>
          <div className="sale-grid">
            {productData.slice(0, 4).map((good, index) => (
              <Link to={`/shopDetails/${good.id}`} onClick={toTop} className="sale-item" key={index}>
                <img src={good.image} alt={good.name} />
                <h3>{good.name}</h3>
                <div className="price">
                  <span className="sale-price">${good.price}</span> 
                </div>
              </Link>
            ))}
          </div>
          <Link to="/shop" onClick={toTop} className="view-all">VIEW ALL</Link>
        </section>

        {/* Collections Section */}
        <section className="brands-section">
          <div className="brand-item">
            <img src="/generated/editorial/scene-02.webp" alt="Indigo collection" />
            <span>Indigo Studies</span>
          </div>
          <div className="brand-item">
            <img src="/generated/editorial/scene-03.webp" alt="Linen collection" />
            <span>Natural Layers</span>
          </div>
          <div className="brand-item">
            <img src="/generated/editorial/scene-04.webp" alt="Modern workwear collection" />
            <span>Modern Workwear</span>
          </div>
        </section>

        {/* Shop the look Section */}
        <section className="shop-the-look">
          <h2>Shop the look</h2>
          <div className="look-container">
            <div className="look-image">
              <img src="/generated/editorial/scene-05.webp" alt="Layered seasonal look" />
              <div className="hotspot"></div>
            </div>
             
          </div>
        </section>

        {/* isanroute Lifestore Section */}
        <section className="lifestore-section">
          <div className="lifestore-hero">
            <img src="/generated/editorial/scene-06.webp" alt="Design store shelves" />
            <div className="lifestore-hero-text">
              <h2>isanroute Lifestore</h2> 
            </div>
          </div>
          <div className="lifestore-grid">
            <div className="lifestore-item">
              <img src="/generated/editorial/scene-07.webp" alt="Linen home textiles" />
              <span>Home Textiles</span>
            </div>
            <div className="lifestore-item">
              <img src="/generated/editorial/scene-08.webp" alt="Everyday care objects" />
              <span>Everyday Care</span>
            </div>
            <div className="lifestore-item">
              <img src="/generated/editorial/scene-09.webp" alt="Sculptural home objects" />
              <span>Objects</span>
            </div>
            <div className="lifestore-item">
              <img src="/generated/editorial/scene-10.webp" alt="Modern tableware" />
              <span>Tableware</span>
            </div>
          </div>
        </section>

        {/* 6 */}
        {/* New In Section */}
        <section className="new-in-section">
          <h2 className="section-title">New In</h2>
          <div className="new-in-grid">
            <div className="new-in-item">
              <img src="/generated/editorial/scene-11.webp" alt="New tailoring" />
              <span className="overlay-text">New Tailoring</span>
            </div>
            <div className="new-in-item black-bg">
              <img src="/generated/editorial/scene-12.webp" alt="Outdoor layers" />
              <span className="overlay-text">Outdoor Layers</span>
            </div>
          </div>
        </section>

        <section className="sale-section">
          <h2>Essential Jackets</h2>
          <div className="sale-grid">
            {productData.slice(4,8).map((good, index) => (
              <Link to={`/shopDetails/${good.id}`} onClick={toTop} className="sale-item" key={index}>
                <img src={good.image} alt={good.name} />
                <h3>{good.name}</h3>
                <div className="price">
                  <span className="sale-price">${good.price}</span> 
                </div>
              </Link>
            ))}
          </div>
          <Link to="/shop" onClick={toTop} className="view-all">VIEW ALL</Link>
        </section>

        {/* Gallery Grid Section */}
        <section className="gallery-grid">
          <div className="gallery-row">
            <div className="gallery-item">
              <img src="/generated/editorial/scene-13.webp" alt="Coffee bar" />
            </div>
            <div className="gallery-item">
              <img src="/generated/editorial/scene-14.webp" alt="Artisan shoes" />
              <span className="overlay-text">Crafted Details</span>
            </div>
            <div className="gallery-item">
              <img src="/generated/editorial/scene-15.webp" alt="Independent storefront" />
              <span className="overlay-text">Spring delivery</span>
            </div>
            <div className="gallery-item">
              <img src="/generated/editorial/scene-16.webp" alt="Warm shop interior" />
            </div>
          </div>
          <div className="gallery-row">
            <div className="gallery-item"><img src="/generated/editorial/scene-17.webp" alt="Parcel packing" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-18.webp" alt="Store collection" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-19.webp" alt="Indigo street style" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-20.webp" alt="Knitwear detail" /></div>
          </div>
        </section>

        <section className="sale-section">
          <h2>Seasonal Selection</h2>
          <div className="sale-grid">
            {productData.slice(8,12).map((good, index) => (
              <Link to={`/shopDetails/${good.id}`} onClick={toTop} className="sale-item" key={index}>
                <img src={good.image} alt={good.name} />
                <h3>{good.name}</h3>
                <div className="price">
                  <span className="sale-price">${good.price}</span> 
                </div>
              </Link>
            ))}
          </div>
          <Link to="/shop" onClick={toTop} className="view-all">VIEW ALL</Link>
        </section>

        {/* Marquee Cafe Section */}
        <section className="marquee-section cafe-section">
          <div className="marquee">
            <div className="marquee-content">
              <span>Proudly independent since 2007. Proudly independent since 2007. Proudly independent since 2007.</span>
            </div>
          </div>
          <div className="full-image-container">
            <img src="/generated/editorial/scene-21.webp" alt="Speciality cafe" />
            <span className="overlay-text">Ground Floor - Speciality Café</span>
          </div>
        </section>

        {/* Marquee Shoe Section */}
        <section className="marquee-section shoe-section">
          <div className="marquee">
            <div className="marquee-content">
              <span>Menswear, lifestore & cafe. Menswear, lifestore & cafe. Menswear, lifestore & cafe.</span>
            </div>
          </div>
          <div className="full-image-container">
            <img src="/generated/editorial/scene-22.webp" alt="Artisan footwear" />
            <div className="overlay-content">
              <h3>isanroute Footwear</h3>
              <span className="subtitle">THE CHUKKA</span>
            </div>
          </div>
        </section>

        {/* Our Store Section */}
        <section className="our-store-section">
          <div className="store-text">
            <h2>Our Store</h2>
            <p>
              isanroute is an independent lifestyle store and café,
              founded on the belief that great design should be
              accessible to everyone. We curate a thoughtfully selected
              range of practical, well-made products, bringing together
              clothing, homewares and everyday objects that balance
              function, quality and quiet character.
            </p>
            <Link to="/about" className="about-link" onClick={toTop}>About Us</Link>
          </div>
          <div className="store-images">
            <img src="/generated/editorial/scene-23.webp" alt="Store front" />
            <img src="/generated/editorial/scene-24.webp" alt="Store interior" />
          </div>
        </section>

        {/* 12 */}
        {/* Latest Section */}
        <section className="latest-section">
          <h2>Latest</h2>
          <div className="latest-grid">
            <div className="latest-item">
              <img src="/generated/editorial/scene-25.webp" alt="Store update" />
              <h3>Store Update</h3>
            </div>
            <div className="latest-item">
              <img src="/generated/editorial/scene-26.webp" alt="Textile story" />
              <h3>Material Notes</h3>
            </div>
            <div className="latest-item">
              <img src="/generated/editorial/scene-27.webp" alt="Officer jacket" />
              <h3>Inside the Officer Jacket</h3>
            </div>
          </div>
          <Link to="/about" onClick={toTop} className="discover-all">DISCOVER ALL OUR STORIES</Link>
        </section>

        {/* Bottom Gallery Section */}
        <section className="bottom-gallery">
          <div className="gallery-row">
            <div className="gallery-item"><img src="/generated/editorial/scene-28.webp" alt="Fabric movement" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-29.webp" alt="Outerwear story" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-30.webp" alt="Boutique at dusk" /></div>
            <div className="gallery-item"><img src="/generated/editorial/scene-31.webp" alt="Ceramic objects" /></div>
          </div>
        </section>

        {/* Opening Hours Section */}
        <section className="opening-hours-section">
          <img src="/generated/editorial/scene-32.webp" alt="isanroute store front" />
          <div className="hours-overlay">
            <h2>Store & Cafe Opening Hours</h2>
            <p>Monday - Saturday: 10am - 6pm.</p>
            <p>Sunday & Bank Holidays: 10am - 5pm.</p>
          </div>
        </section>

      </main>
    </div>
  );
}

export default Main;
